export const staticMode = 'static';
export const dynamicVerticalMode = 'dynamic-vertical';
export const all = [staticMode, dynamicVerticalMode];

export default {
  static: staticMode,
  dynamicVertical: dynamicVerticalMode,
  all
};
